import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00400-conditions-form" }
const _hoisted_2 = { class: "row q-gutter-x-sm" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  class: "col q-gutter-x-xs flex justify-end",
  style: {"margin-top":"10px"}
}
const _hoisted_8 = { class: "cmd00400-result-table" }
const _hoisted_9 = { class: "full-width row q-gutter-sm" }
const _hoisted_10 = { class: "q-pt-xs" }
const _hoisted_11 = { class: "add-btn-area flex items-center filter-select" }
const _hoisted_12 = { class: "flex" }

import Loading from 'quasar/src/plugins/Loading.js';;
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import DisplayModeCode from '../../common/code/DisplayModeCode';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';

interface MCustomer {
  customer_code: string;
  customer_name: string;
  is_deleted: string;
  create_timestamp: Date;
  update_timestamp: Date;
  create_user_name: string;
  update_user_name: string;
}

// 検索条件：得意先コード

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00400',
  setup(__props) {

const customerCode = ref('');
// 検索条件：得意先コード
const customerName = ref('');
// 検索条件：無効データを含む
const isAllSearch = ref(false);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'edit',
    field: (row: MCustomer) => row.customer_code,
  },
  {
    name: 'customer_code',
    label: '得意先コード',
    align: 'left',
    field: (row: MCustomer) => row.customer_code,
    style: 'width: 100px',
    sortable: true,
  },
  {
    name: 'customer_name',
    label: '得意先名｜納品場所',
    align: 'left',
    field: (row: MCustomer) => row.customer_name,
    sortable: true,
  },

  {
    name: 'create_user_name',
    label: '登録者',
    align: 'left',
    field: (row: MCustomer) => row.create_user_name,
    sortable: true,
  },

  {
    name: 'create_timestamp',
    label: '登録日時',
    align: 'left',
    field: (row: MCustomer) => row.create_timestamp,
    style: 'width: 170px',
    sortable: true,
  },
  {
    name: 'update_user_name',
    label: '更新者',
    align: 'left',
    field: (row: MCustomer) => row.update_user_name,
    sortable: true,
  },

  {
    name: 'update_timestamp',
    label: '更新日時',
    align: 'left',
    field: (row: MCustomer) => row.update_timestamp,
    style: 'width: 170px',
    sortable: true,
  },
];

const rows = ref([
  {
    customer_code: '',
    customer_name: '',
    is_deleted: '',
    create_user_name: '',
    create_timestamp: '',
    update_user_name: '',
    update_timestamp: '',
  },
]);

const router = useRouter();
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// 得意先検索
const searchCustomer = async () => {
  // Loading Start
  Loading.show();
  // 検索条件設定
  const formData = new FormData();
  formData.append('customer_code', customerCode.value);
  formData.append('customer_name', customerName.value);
  formData.append('is_all_search', isAllSearch.value.toString());

  await axios
    .post('/cmd004001/search', formData)
    .then((res) => {
      const { common, customerList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          rows.value = customerList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          // エラーメッセージ表示
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

// 追加ボタン押下
const addData = () => {
  router.push({ name: 'customerRegist', params: { mode: DisplayModeCode.REGISTER } });
};

// テーブル内編集ボタン押下
const editData = (customerCd: string) => {
  router.push({ name: 'customerEdit', params: { mode: DisplayModeCode.CHANGE, customerCd } });
};

// 検索条件クリア
const clearSearchCondition = () => {
  customerCode.value = '';
  customerName.value = '';
  isAllSearch.value = false;
};

// 初期表示
searchCustomer();

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode("得意先および掛け率一覧")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_card, {
        style: {"background":"var(--q-lightGray)","margin-bottom":"70px"},
        flat: "",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-gutter-y-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", null, "得意先コード", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: customerCode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerCode).value = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "7"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, "得意先名｜納品場所", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: customerName.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerName).value = $event)),
                    outlined: "",
                    dense: "",
                    style: {"background":"var(--q-white)"},
                    class: "input-area",
                    maxlength: "100"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_q_checkbox, {
                    modelValue: isAllSearch.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isAllSearch).value = $event)),
                    label: "無効データを含む"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    style: {"width":"150px"},
                    label: "検索",
                    icon: "mdi-magnify",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (searchCustomer()))
                  }),
                  _createVNode(_component_q_btn, {
                    outline: "",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: "mdi-eraser",
                    label: "クリア",
                    onClick: clearSearchCondition
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' + (rows.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: rows.value,
          columns: columns,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_btn, {
                icon: "mdi-plus",
                label: "追加",
                class: "add-btn",
                color: "primary",
                onClick: addData
              })
            ])
          ]),
          "header-cell-edit": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area" })
          ]),
          "body-cell-edit": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  class: _normalizeClass('table-btn-area ' + (cell.row.is_deleted === '1' ? 'deleted' : ''))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_q_btn, {
                        icon: "mdi-pencil",
                        label: "編集",
                        color: "primary",
                        onClick: ($event: any) => (editData(cell.row.customer_code))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["class"]))
              : _createCommentVNode("", true)
          ]),
          "body-cell": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  props: cell,
                  class: _normalizeClass(cell.row.is_deleted === '1' ? 'deleted' : '')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.value), 1)
                  ]),
                  _: 2
                }, 1032, ["props", "class"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows", "hide-no-data", "pagination-label"])
      ], 2)
    ])
  ]))
}
}

})